import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';

// پرلود کردن همه مدل‌ها
useGLTF.preload('/models/dragon.glb');
useGLTF.preload('/models/owl.glb');
useGLTF.preload('/models/unicorn.glb');
useGLTF.preload('/models/robot.glb');
useGLTF.preload('/models/phoenix.glb');
useGLTF.preload('/models/whale.glb');

const ModelLoader = ({ modelPath, scale = 2.5, position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const { scene } = useGLTF(modelPath);
  const modelRef = useRef();

  useFrame(({ clock }) => {
    if (modelRef.current) {
      modelRef.current.position.y = Math.sin(clock.getElapsedTime() * 0.8) * 0.1;
      modelRef.current.rotation.y += 0.003;
    }
  });

  return (
    <primitive
      ref={modelRef}
      object={scene.clone()}
      scale={scale}
      position={position}
      rotation={rotation}
    />
  );
};

export default ModelLoader;